import type { ExtractPropTypes, PropType } from 'vue'

export type SwitchSize = 'large' | 'default' | 'small'

export const switchProps = {
  /**
   * 绑定值，支持v-model
   */
  modelValue: {
    type: [Boolean, String, Number],
    default: false
  },
  /**
   * 开关的尺寸
   */
  size: {
    type: String as PropType<SwitchSize>,
    default: 'default'
  },
  /**
   * 是否禁用
   */
  disabled: {
    type: Boolean,
    default: false
  },
  /**
   * 打开时的值
   */
  activeValue: {
    type: [Boolean, String, Number],
    default: true
  },
  /**
   * 关闭时的值
   */
  inactiveValue: {
    type: [Boolean, String, Number],
    default: false
  },
  /**
   * 打开时的文字
   */
  activeText: {
    type: String,
    default: ''
  },
  /**
   * 关闭时的文字
   */
  inactiveText: {
    type: String,
    default: ''
  },
  /**
   * 开关的名称
   */
  name: {
    type: String,
    default: ''
  },
  /**
   * 打开时的颜色
   */
  activeColor: {
    type: String,
    default: '#409EFF'
  },
  /**
   * 关闭时的颜色
   */
  inactiveColor: {
    type: String,
    default: '#C0CCDA'
  },
  /**
   * 是否显示加载中
   */
  loading: {
    type: Boolean,
    default: false
  },
  /**
   * 开关的宽度
   */
  width: {
    type: [String, Number],
    default: ''
  },
  /**
   * 是否在切换时触发验证
   */
  validateEvent: {
    type: Boolean,
    default: true
  }
} as const

export type SwitchProps = Partial<ExtractPropTypes<typeof switchProps>>

export const switchEmits = {
  'update:modelValue': (value: boolean | string | number) => true,
  'change': (value: boolean | string | number) => true,
  'input': (value: boolean | string | number) => true
}

export type SwitchEmits = typeof switchEmits